import { render, staticRenderFns } from "./IconChevronDoubleRightSolid.vue?vue&type=template&id=57d67704"
import script from "./IconChevronDoubleRightSolid.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleRightSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports